module.exports = __webpack_public_path__ + "static/1-002-13e062b50da3587caf8385b19c96c761.png";